import { render, staticRenderFns } from "./archived-project.vue?vue&type=template&id=01e049f1&scoped=true&"
import script from "./archived-project.vue?vue&type=script&lang=js&"
export * from "./archived-project.vue?vue&type=script&lang=js&"
import style0 from "./archived-project.vue?vue&type=style&index=0&id=01e049f1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e049f1",
  null
  
)

export default component.exports